import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import CTASection from '../components/CTASection';
import './About.css';
import './Services.css';

const allServices = [
  {
    category: 'Individual',
    icon: '👤',
    title: 'Individual Tax Services',
    desc: 'Comprehensive tax filing for W-2 employees, freelancers, and gig workers. We maximize every credit and deduction you\'re entitled to.',
    items: ['W2 Tax Filing', '1099 / Self-Employed (Uber, Lyft, CNA, etc.)', 'Amended Returns (1040X)', 'ITIN Applications', 'Multiple State Returns', 'Prior Year Returns'],
  },
  {
    category: 'Business',
    icon: '🏢',
    title: 'Business Tax Services',
    desc: 'Tailored tax solutions for LLCs, small businesses, and trucking companies. We optimize your deductions and keep you compliant.',
    items: ['LLC & Small Business Filing', 'Trucking Business Taxes', 'Schedule C Optimization', 'Quarterly Estimated Taxes', 'S-Corp Returns', 'Partnership Returns'],
  },
  {
    category: 'Special',
    icon: '🛠️',
    title: 'Special Services',
    desc: 'Got an IRS issue? We handle audits, notices, and complex tax situations quickly and professionally.',
    items: ['IRS Letter Help (CP2000, Audits)', 'Refund Maximization Strategy', 'Tax Planning', 'Back Tax Filing', 'Penalty Abatement', 'Tax Lien Assistance'],
  },
  {
    category: 'Gig',
    icon: '🚗',
    title: 'Gig Economy Taxes',
    desc: 'Specialized in gig worker taxes. We know every deduction for drivers, delivery workers, and freelancers.',
    items: ['Uber & Lyft Driver Taxes', 'DoorDash / Instacart / Amazon Flex', 'Freelancer Tax Returns', 'Home Office Deductions', 'Mileage & Vehicle Deductions', 'Business Expense Write-offs'],
  },
  {
    category: 'Refund',
    icon: '💰',
    title: 'Refund Maximization',
    desc: 'Our experts audit your return for every possible credit and deduction to ensure you get the maximum refund legally allowed.',
    items: ['Child Tax Credit Review', 'EITC Eligibility Check', 'Education Credits', 'Deduction Finder Analysis', 'Dependent Care Credits', 'Energy Credits'],
  },
  {
    category: 'IRS',
    icon: '⚖️',
    title: 'IRS Resolution',
    desc: 'Don\'t face the IRS alone. We represent you and resolve issues quickly, protecting your finances and peace of mind.',
    items: ['Audit Representation', 'CP2000 Notice Response', 'Payment Plan Assistance', 'Offer in Compromise', 'Innocent Spouse Relief', 'Wage Garnishment Help'],
  },
];

const categories = ['All', 'Individual', 'Business', 'Special', 'Gig', 'Refund', 'IRS'];

const Services = () => {
  const [active, setActive] = useState('All');

  const filtered = active === 'All'
    ? allServices
    : allServices.filter(s => s.category === active);

  return (
    <>
      <div className="page-header">
        <div className="container">
          <div className="section-label">What We Offer</div>
          <h1>Our Tax <em>Services</em></h1>
          <p>Comprehensive tax solutions for individuals, families, and businesses across all 50 states.</p>
        </div>
      </div>

      <section className="section">
        <div className="container">
          {/* Filter Tabs */}
          <div className="services-filter">
            {categories.map(cat => (
              <button
                key={cat}
                className={`filter-btn ${active === cat ? 'filter-btn-active' : ''}`}
                onClick={() => setActive(cat)}
              >
                {cat}
              </button>
            ))}
          </div>

          {/* Services Grid */}
          <div className="services-full-grid">
            {filtered.map(s => (
              <div className="service-full-card" key={s.title}>
                <div className="sfc-icon">{s.icon}</div>
                <div className="sfc-body">
                  <h3>{s.title}</h3>
                  <p>{s.desc}</p>
                  <ul>
                    {s.items.map(item => <li key={item}>{item}</li>)}
                  </ul>
                  <Link to="/contact" className="btn btn-navy" style={{ marginTop: '20px', fontSize: '14px', padding: '10px 22px' }}>
                    Get Started →
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTASection />
    </>
  );
};

export default Services;
